import { z } from "zod";
//#region src/fixture-manifest-resync.ts
/**
* The fixture-manifest resync of release-engine,
* `POST /v1/releases/apps/:appId/fixture-manifests/resync` (`AppCompositionService.resyncFixtureManifests`;
* plan 2026-10-21-operator-tui, R-054e, F1).
*
* The route has no dry run. It re-derives the fixture manifests of one composition from its
* published artifact and upserts each row. Its refusals run before the first upsert and write
* nothing: for a bound version, a fetched bundle digest other than the stored `bundleDigest`
* (`assertBoundResyncDigest`); a fixture that declares a removed surface; and an `apiPath` overlap
* (`validateAppApiPathsOverlap`). Each refusal is a 400.
*/
/** The upper bound of the `version` query value, the `RESYNC_VERSION_MAX_LENGTH` of release-engine. */
const FIXTURE_MANIFEST_RESYNC_VERSION_MAX_LENGTH = 64;
/** One fixture the resync wrote. `changed` is `true` when the stored manifest differs from the one before. */
const fixtureManifestResyncFixtureSchema = z.object({
	fixtureId: z.string().min(1),
	version: z.string().min(1),
	changed: z.boolean()
}).strict();
/** One `apiPath` namespace violation in the artifact. The resync reports it and still writes. */
const fixtureManifestResyncNamespaceIssueSchema = z.object({
	fixtureId: z.string().min(1),
	path: z.string(),
	rule: z.string(),
	message: z.string()
}).strict();
/**
* The answer of the resync. `appVersion` names the composition the resync used: the latest one,
* or the one the `version` query named. `legacyFixtureVersionKeyStripped` lists the fixture ids
* whose legacy `fixtures.<id>.version` key the resync dropped; `[]` when none.
*/
const fixtureManifestResyncResponseSchema = z.object({
	appSlug: z.string().min(1),
	appVersion: z.string().min(1),
	artifactRef: z.string().min(1),
	fixtures: z.array(fixtureManifestResyncFixtureSchema),
	namespaceIssues: z.array(fixtureManifestResyncNamespaceIssueSchema),
	legacyFixtureVersionKeyStripped: z.array(z.string())
}).strict();
//#endregion
export { FIXTURE_MANIFEST_RESYNC_VERSION_MAX_LENGTH, fixtureManifestResyncFixtureSchema, fixtureManifestResyncNamespaceIssueSchema, fixtureManifestResyncResponseSchema };

//# sourceMappingURL=fixture-manifest-resync.js.map